const menus = [
  {
    title: 'Destinations',
    url: '/destination',
    role: ['admin'],
    branch: ['ID', 'PH'],
    subs: [
      {
        title: 'Manage Destination',
        url: '/destination/manage',
        role: ['admin'],
        branch: ['ID', 'PH']
      },
      {
        title: 'Continent Mapping',
        url: '/destination/mapping',
        role: ['admin'],
        branch: ['ID', 'PH']
      }
    ]
  },
  {
    title: 'Attractions',
    url: '/attractions',
    role: ['admin'],
    branch: ['ID', 'PH'],
    subs: [
      {
        title: 'Manage Attractions',
        url: '/attractions',
        role: ['admin'],
        branch: ['ID', 'PH']
      },
      {
        title: 'Manage Popular Attractions',
        url: '/attractions/popular',
        role: ['admin'],
        branch: ['ID', 'PH']
      },
      {
        title: 'Attraction Mapping',
        url: '/attractions/new-attraction-mapping',
        role: ['admin'],
        branch: ['ID']
      },
      {
        title: 'Reviews',
        url: '/attractions/reviews',
        role: ['admin'],
        branch: ['ID', 'PH']
      },
      {
        title: 'Cron Report Tools',
        url: '/attractions/cron-report',
        role: 'admin',
        branch: ['ID']
      }
    ]
  },
  {
    title: 'Wifi Product',
    url: '/product',
    role: ['admin'],
    branch: ['ID', 'PH']
  },
  {
    title: 'eSIM',
    url: '/esim',
    role: ['admin'],
    branch: ['ID']
  },
  {
    title: 'Coupon',
    url: '/coupon',
    role: ['admin', 'finance'],
    branch: ['ID', 'PH'],
    subs: [
      {
        title: 'Manage Coupon',
        url: '/coupon/manage-coupon',
        role: ['admin', 'finance'],
        branch: ['ID', 'PH']
      },
      {
        title: 'Manage Provider',
        url: '/coupon/manage-provider',
        role: ['admin', 'finance'],
        branch: ['ID']
      },
      {
        title: 'Manage Sobat Affiliate',
        url: '/coupon/manage-affiliate',
        role: ['admin', 'finance'],
        branch: ['ID']
      }
    ]
  },
  {
    title: 'Events',
    url: '/events',
    role: ['admin', 'cs', 'finance'],
    branch: ['ID'],
    subs: [
      {
        title: 'Events List',
        url: '/events/events-list',
        role: ['admin', 'cs', 'finance'],
        branch: ['ID']
      },
      {
        title: 'Popular Events',
        url: '/events/popular-events',
        role: ['admin', 'cs', 'finance'],
        branch: ['ID']
      },
      {
        title: 'Events Categories',
        url: '/events/events-categories',
        role: ['admin', 'cs', 'finance'],
        branch: ['ID']
      }
    ]
  },
  {
    title: 'Insurance',
    url: '/insurance',
    role: ['admin', 'cs', 'finance'],
    branch: ['ID'],
    subs: [
      {
        title: 'Travel Package',
        url: '/insurance/travel-package-list',
        role: ['admin', 'cs', 'finance'],
        branch: ['ID']
      },
      {
        title: 'Ticket Package',
        url: '/insurance/ticket-package-list',
        role: ['admin', 'cs', 'finance'],
        branch: ['ID']
      }
    ]
  },
  {
    title: 'E-commerce',
    url: '/e-commerce',
    role: ['admin', 'finance'],
    branch: ['ID', 'PH'],
    subs: [
      {
        title: 'Manage Category',
        url: '/e-commerce/manage-category',
        role: ['admin', 'finance'],
        branch: ['ID', 'PH']
      },
      {
        title: 'Manage Variant',
        url: '/e-commerce/manage-variant',
        role: ['admin', 'finance'],
        branch: ['ID', 'PH']
      },
      {
        title: 'Manage Brand',
        url: '/e-commerce/manage-brand',
        role: ['admin', 'finance'],
        branch: ['ID', 'PH']
      },
      {
        title: 'Manage Warehouse',
        url: '/e-commerce/manage-warehouse',
        role: ['admin', 'finance'],
        branch: ['ID', 'PH']
      },
      {
        title: 'Manage Inventory',
        url: '/e-commerce/manage-inventory',
        role: ['admin', 'finance'],
        branch: ['ID', 'PH']
      },
      {
        title: 'Manage Product',
        url: '/e-commerce/manage-ecommerce-product',
        role: ['admin', 'finance'],
        branch: ['ID', 'PH']
      },
      {
        title: 'Manage Supplier',
        url: '/e-commerce/manage-supplier',
        role: ['admin', 'finance'],
        branch: ['ID', 'PH']
      },
      {
        title: 'Manage Order',
        url: '/e-commerce/manage-ecommerce-order',
        role: ['admin', 'finance'],
        branch: ['ID']
      }
    ]
  },
  {
    title: 'Order',
    url: '/order',
    role: ['admin', 'cs', 'finance', 'admin_travy'],
    branch: ['ID', 'PH'],
    subs: [
      {
        title: 'Order List',
        url: '/order/list',
        role: ['admin', 'cs', 'finance', 'admin_travy'],
        branch: ['ID', 'PH']
      },
      {
        title: 'Order Detail List',
        url: '/order/detail-list',
        role: ['admin', 'cs', 'finance'],
        branch: ['ID', 'PH']
      },
      {
        title: 'Auto Transfer List',
        url: '/order/auto-transfer',
        role: ['admin', 'cs', 'finance'],
        branch: ['ID']
      },
      {
        title: 'Chatbot Order List',
        url: '/order/chatbot-list',
        role: ['admin', 'cs', 'finance'],
        branch: ['ID']
      },
      {
        title: 'Change Status',
        url: '/order/change-status',
        role: ['admin', 'cs', 'finance'],
        branch: ['ID']
      }
    ]
  },
  {
    title: 'User',
    url: '/user',
    role: ['admin'],
    branch: ['ID', 'PH'],
    subs: [
      {
        title: 'User list',
        url: '/user/list',
        role: ['admin'],
        branch: ['ID', 'PH']
      },
      {
        title: 'User count by date',
        url: '/user/count',
        role: ['admin'],
        branch: ['ID', 'PH']
      }
    ]
  },
  {
    title: 'Misc.',
    url: '/misc',
    role: 'admin',
    branch: ['ID', 'PH'],
    subs: [
      {
        title: 'Banners',
        url: '/misc/banners',
        role: 'admin',
        branch: ['ID', 'PH']
      },
      {
        title: 'Markup',
        url: '/misc/markup',
        role: 'admin',
        branch: ['ID', 'PH']
      },
      {
        title: 'Exchange Rate',
        url: '/misc/exchange-rate',
        role: 'admin',
        branch: ['ID']
      },
      {
        title: 'Sections',
        url: '/misc/section-page',
        role: 'admin',
        branch: ['ID']
      },
      {
        title: 'Shipping Preset',
        url: '/misc/shipping-preset',
        role: 'admin',
        branch: ['ID']
      },
      {
        title: 'Attraction Promo',
        url: '/misc/attraction-promo',
        role: 'admin',
        branch: ['ID']
      },
      {
        title: 'Promo Section',
        url: '/misc/promo-section',
        role: 'admin',
        branch: ['ID']
      },
      {
        title: 'Failed Transaction',
        url: '/misc/failed-transaction',
        role: 'admin',
        branch: ['ID']
      },
      {
        title: 'Scheduler',
        url: '/misc/scheduler',
        role: 'admin',
        branch: ['ID']
      }
    ]
  },
  {
    title: 'Travelinpod',
    url: '/travypass',
    role: ['admin', 'admin_travy'],
    branch: ['ID'],
    subs: [
      {
        title: 'Manage Travelinpod',
        url: '/travypass/manage-travypass',
        role: ['admin'],
        branch: ['ID']
      },
      {
        title: 'Order Report',
        url: '/travypass/order-report',
        role: ['admin', 'admin_travy'],
        branch: ['ID']
      }
    ]
  },
  {
    title: 'Manage Admin',
    url: '/manage-admin',
    role: ['admin'],
    branch: ['ID'],
    hidden: true
  }
]

export default menus



// WEBPACK FOOTER //
// ./src/Routes/menus.js